import {Injectable} from "@angular/core";
import {AppService} from "../../../core/services/app.service";
import {HttpClient} from "@angular/common/http";
import {ReplaySubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class WordpressService {
    public menuWordpressAPI = AppService.getApiUrl() + '/api/wpmenus/';
    public subject;
    public returnSubject;

    constructor(public http: HttpClient) {
        this.returnSubject = new ReplaySubject();

        this.http.get(this.menuWordpressAPI).subscribe(this.returnSubject);

    }

    getMenu() {
        return this.returnSubject;
    }
    
    getPopUpMarker() {
        return this.http.get(AppService.getApiUrl() + '/api/customers/defaultInfo/popMarker');
    }
}
